MultiStepForm[2] = {
  city: false,
  postal_index: false,
  street: false,
  house_number: false,
  housing_type: false,
}

const regex_address = /^[a-záçéèíïñòóúüÀÇÉÈÍÏÒÓÜÚ/\s'-]+$/iu
const regex_postal_index = /^(0[1-9]|[1-4][0-9]|5[0-2])[-]?\d{3}$/
const regex_house_number = /^\d+[a-záçéèíïñòóúüÀÇÉÈÍÏÒÓÜÚ]?$/iu
const regex_street = /^[a-z0-9áçéèíïñòóúüÀÇÉÈÍÏÒÓÜÚ/\s'-]+$/iu

const validateAddress = (value) => {
  return regex_address.test(value)
}

const validatePostalIndex = (value) => {
  return regex_postal_index.test(value)
}

const validateHouseNumber = (value) => {
  return regex_house_number.test(value)
}

const validateStreet = (value) => {
  return regex_street.test(value)
}

jQuery(document).ready(function ($) {
  $("body").on("keyup", "#form-input-step-2 input", function () {
    const value = $(this).val()
    const name = $(this).data("name")
    const field = $(this).data("label").replace(/-/g, " ").toLowerCase()

    let success = false

    if (name == "city") {
      success = validateAddress(value)
    } else if(name == "street") {
      success = validateStreet(value)
    } else if(name == "postal_index") {
      success = validatePostalIndex(value)
    } else if(name == "house_number") {
      success = validateHouseNumber(value)
    }

    if (success) {
      showSuccess(2, name)
    } else {
      showError(2, name, field, value)
    }
  })

  $("body").on("change", "#form-selector-step-2 select", function () {
    const value = $(this).val()
    const name = $(this).data("name")
    const field = $(this).data("label").replace(/-/g, " ").toLowerCase()

    if (value) {
      showSuccess(2, name)
    } else {
      const message = `Por favor, selecciona tu ${field}.`
      showError(2, name, field, value, message)
    }
  })

  $("body").on("click", "#submit-button-step-2", function (event) {
    event.preventDefault()
    submitForm(2)
  })

  $("body").on("click", "#previous-button-step-2", function (event) {
    event.preventDefault()
    showPreviousForm(1)
  })

  $("body").on("click", "#mobile-previous-button-step-2", function (event) {
    event.preventDefault()
    showPreviousForm(1)
  })

  $("body").on("click", "#sidebar-step-1", function (event) {
    event.preventDefault()
    showPreviousForm(1, "sidebar")
  })
})
